@if (!isStepPrerequisiteCompleted()) {
  <app-previous-step-incomplete-notice />
} @else {
  <div class="overall-results-overview">
    <p-card>
      <div class="overview-content">
        <div class="overview-header">
          <div class="overview-headline">
            <h2 class="overview-title">
              {{ 'project.steps.overallResults.overview.title' | transloco }}
            </h2>
            <p class="overview-description">
              {{ 'project.steps.overallResults.overview.description' | transloco }}
            </p>
          </div>
        </div>

        @if (isLoadingData()) {
          <app-loading />
        } @else if (summaryTiles().length > 0) {
          <div class="summary-tiles">
            @for (tile of summaryTiles(); track tile.labelKey) {
              <article [ngClass]="['summary-tile', 'summary-tile--' + tile.variant]">
                <div class="summary-tile-header">
                  <i [class]="tile.icon + ' summary-tile-icon'"></i>
                  <span class="summary-tile-label">
                    {{ tile.labelKey | transloco }}
                  </span>
                </div>

                <div class="summary-tile-body">
                  <p class="summary-tile-tool">{{ tile.toolName }}</p>
                  @if (tile.currencyData) {
                    <p class="summary-tile-value">
                      {{ tile.value | appCurrency: tile.currencyData : 0 : 0 }}
                    </p>
                  } @else {
                    <p class="summary-tile-value">{{ tile.value }}</p>
                  }
                </div>
              </article>
            }
          </div>
        }

        @if (!isLoadingData()) {
          <p-tabs
            appTabsUnsavedReveal
            [value]="selectedView()"
            (valueChange)="onViewChange($event!)"
            scrollable
          >
            <p-tablist>
              <p-tab
                [value]="OVERALL_RESULT_VIEW.EXECUTIVE_SUMMARY"
                [appTabStatus]="completedTabStatus"
              >
                {{ 'project.steps.overallResults.view.executiveSummary' | transloco }}
              </p-tab>
              <p-tab
                [value]="OVERALL_RESULT_VIEW.DETAILED_ANALYSIS"
                [appTabStatus]="completedTabStatus"
              >
                {{ 'project.steps.overallResults.view.detailedAnalysis' | transloco }}
              </p-tab>
              <p-tab
                [value]="OVERALL_RESULT_VIEW.COST_COMPARISON"
                [appTabStatus]="completedTabStatus"
              >
                {{ 'project.steps.overallResults.view.costComparison' | transloco }}
              </p-tab>
              <p-tab
                [value]="OVERALL_RESULT_VIEW.MODULE_COMPARISON"
                [appTabStatus]="completedTabStatus"
              >
                {{ 'project.steps.overallResults.view.moduleComparison' | transloco }}
              </p-tab>
            </p-tablist>

            <div class="view-content">
              <p-tabpanels>
                <p-tabpanel [value]="OVERALL_RESULT_VIEW.EXECUTIVE_SUMMARY">
                  <app-executive-summary [providerResults]="providerResults()" />
                </p-tabpanel>
                <p-tabpanel [value]="OVERALL_RESULT_VIEW.DETAILED_ANALYSIS">
                  <app-detailed-analysis
                    [projectId]="projectId()"
                    [includedHrToolDirectusIds]="completedRfqToolIds()"
                  />
                </p-tabpanel>
                <p-tabpanel [value]="OVERALL_RESULT_VIEW.COST_COMPARISON">
                  <app-cost-comparison
                    [projectId]="projectId()"
                    [providerResults]="providerResults()"
                  />
                </p-tabpanel>
                <p-tabpanel [value]="OVERALL_RESULT_VIEW.MODULE_COMPARISON">
                  <app-module-comparison
                    [projectId]="projectId()"
                    [providerResults]="providerResults()"
                  />
                </p-tabpanel>
              </p-tabpanels>
            </div>
          </p-tabs>
        }
      </div>
    </p-card>
  </div>
}
